import { createFileRoute } from "@tanstack/react-router"
import {
	clearHighlightedThoughts,
	recordDiaryPageVisit,
} from "@/entities/thoughts"

export const Route = createFileRoute("/_authenticated/diary")({
	onEnter: recordDiaryPageVisit,
	onLeave: clearHighlightedThoughts,
})
